import { FuseNavigationItem } from '@fleet/model';
export const operatorUserNavigation: FuseNavigationItem[] = [
  {
    title: 'Finance',
    type: 'group',
    securityFunctions: ['OPERATOR_INVOICE_SEARCH:read'],
    children: [
      {
        title: 'Invoices',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: './invoices',
        securityFunctions: ['OPERATOR_INVOICE_SEARCH:read'],
      },
    ],
  },
  {
    title: 'Settings',

    type: 'group',

    children: [
      {
        title: 'General',
        link: './settings',
        type: 'basic',
        icon: 'heroicons_outline:cog',
        securityFunctions: ['OPERATOR_SETTINGS:read'],
      },
    ],
  },
];
